<div class="login-body" *ngIf="displayAuthenPage">
    <div class="login-panel p-fluid">
        <ng-container>
            <form [formGroup]="authenticationSetupForm">
                <div class="p-grid" *ngIf="authenticationSetup" style="margin-left: -60px;margin-right: -60px;">
                    <div class="p-col-12 logo-container p-pb-0">
                        <img [src]="assestBaseUrl + 'layout/images/lionO360_logo1.png'"  alt="logo-dark" />
                        <h4 class="p-mt-4 p-mb-2">Two-Step Verification Method</h4>
                    </div>

                    <div class="p-col-12 p-text-left p-pt-0">
                        <p>Every time you log in, you will be given a verification code. What is your preferred
                            method to
                            receive your verification code?</p>
                        <ng-container *ngFor="let option of verificationOptions">
                            <div class="p-field-radiobutton p-mb-0">
                                <p-radioButton name="verification" [value]="option.value" formControlName="verification"
                                    inputId="verification" (onClick)="onSelectAuthenType()"></p-radioButton>
                                <label [for]="option.value"><b>{{ option.label }}</b></label>
                            </div>
                            <p class="p-mb-0 p-ml-5 p-mb-5">{{ option.description }}</p>
                        </ng-container>
                    </div>

                    <!-- #region authentication setup back and next button popup 1  -->
                    <div class="p-mt-6 p-d-flex p-jc-between w-100">
                        <button pButton type="button" label="Back" (click)="onBackClicked()" class="p-button-secondary"
                            style="width: auto;"></button>
                        <button pButton type="button" label="Next" (click)="next()"
                            [disabled]="!this.authenticationSetupForm.get('verification').value"
                            style="width: auto;"></button>
                    </div>
                </div>

                <ng-container>
                    <ng-container *ngIf="secondStepAuthenticationSetup">
                        <div style="margin-left: -150px;margin-right: -150px;">
                            <div class="p-text-center">
                                <ng-container *ngIf="displayAuthentication">
                                    <h6>Register LionO360</h6>
                                    <p>Scan this QR code with a authentication app such as Microsoft
                                        Authenticator or Google Authenticator.
                                    </p>
                                    <img [src]="authenticationSetupForm?.get('qrCodeSrc')?.value" alt="QR code"
                                        width="100" />
                                    <p>Or enter the following code: <strong (click)="copyManualSetupKey()"
                                            style="cursor: pointer;"> {{manualSetupKey}} <i class="pi pi-copy"
                                                pTooltip="Copy Manual Setup Key"></i></strong></p>
                                    <div>Once you connect your LionO360 account to the authentication app, you'll get a
                                        6 digit code.
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                        <div *ngIf="displaySMS" style="margin-left: -150px;margin-right: -150px;">
                            <div class="card p-text-center">
                                <ng-container>
                                    <h6>The verification code will be sent to the phone number provided below.</h6>
                                    <p-dropdown [options]="countryData" [filter]="true" filterBy="CountryName"
                                        optionLabel="CountryName" stand [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="selectedCountry" (onChange)="onCountrySelect($event)"
                                        class="inline"></p-dropdown>
                                    <div class="p-inputgroup inline">
                                        <span class="p-inputgroup-addon">+{{selectedCountry?.PhoneCode}}</span>
                                        <input type="text" style="width: 250px; height: 30px;" pInputText
                                            formControlName="phoneNumber">
                                        <div class="p-mt-1"
                                            *ngIf="authenticationSetupForm.get('phoneNumber').invalid && authenticationSetupForm.get('phoneNumber').touched">
                                            <small class="p-invalid">Please enter a valid phone number.</small>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                        <div *ngIf="displayEmail" style="margin-left: -150px;margin-right: -150px;">
                            <div class="card p-text-center">
                                <ng-container>
                                    <h6>The verification code will be sent to the email provided below.</h6>
                                    <input type="text" pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
                                        formControlName="email" pInputText style="width: 250px;" class="p-ml-2" />
                                    <div class="p-mt-1"
                                        *ngIf="authenticationSetupForm.get('email').invalid && authenticationSetupForm.get('email').touched">
                                        <small class="p-invalid">Please enter a valid email address.</small>
                                    </div>
                                </ng-container>
                            </div>

                        </div>

                        <div class="p-mt-6 p-d-flex p-jc-between w-100 p-px-5">
                            <button type="button" pButton (click)="onAuhtenSetupBackButton()" label="Back"
                                class="p-button-secondary" style="width: auto;"></button>
                            <button type="button" pButton label="Next"
                                [disabled]="!authenticationSetupForm.get('phoneNumber').valid || !authenticationSetupForm.get('email').valid "
                                (click)="onAuthenSetupNextButton()" style="width: auto;"></button>
                        </div>
                    </ng-container>
                    <ng-conatainer *ngIf="finalAuthenticationSetup">
                        <div style="margin-left: -150px;margin-right: -150px;">
                            <div class="p-text-center">
                                <ng-container [ngSwitch]="authenticationSetupForm.get('verification').value">
                                    <ng-container *ngSwitchCase="'AuthenticatorApp'">
                                        <h6>Verify Authentication App</h6>
                                        <p><strong>Enter the 6 digit code from the Authenticator app.</strong></p>
                                        <input type="text" pInputText style="width: 300px;"
                                            formControlName="verificationCode" placeholder="Enter your 6 digit code"/>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'SMS'">
                                        <h6>{{authenticationSetupForm?.get('phoneNumber')?.value }}</h6>
                                        <p><strong>Enter the 6 digit code sent to your phone number.</strong></p>
                                      
                                        <input type="text" pInputText style="width: 300px;"
                                            formControlName="verificationCode" placeholder="Enter your 6 digit code" (keypress)="preventSpace($event)" />
                                            <span class="p-mt-1 p-d-block">Didn't receive the Code? Click Resend in {{ formatTimer() }}</span> 
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'Email'">
                                        <h6>{{authenticationSetupForm?.get('email')?.value }}</h6>
                                        <p><strong>Enter the 6 digit code sent to your email.</strong>
                                        </p>
                                       
                                        <input type="text" pInputText style="width: 300px;"
                                            formControlName="verificationCode" placeholder="Enter your 6 digit code" (keypress)="preventSpace($event)" />
                                        <span class=" p-d-block p-mt-1 p-mr-3">Didn't receive the Code? Click Resend in {{ formatTimer() }}</span>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>

                        <div class="p-mt-6 p-d-flex p-jc-between w-100 p-px-5">
                            <button type="button" pButton (click)="lastBackButton()" label="Back"
                                class="p-button-secondary" style="width: auto;"></button>
                            <button  *ngIf="authenticationSetupForm.get('verification').value !== 'AuthenticatorApp'" type="button" pButton label="Resend" [disabled]="resendButtonDisabled" (click)="resend()" class="p-button-secondary"
                                style="width: auto;"></button>
                            <button type="button" pButton label="Done" style="width: auto;" (click)="onClickDone()"
                                [disabled]="!this.authenticationSetupForm.get('verificationCode').value"></button>
                        </div>
                        
                    </ng-conatainer>
                </ng-container>
            </form>
        </ng-container>

        <div class="p-grid" *ngIf="authenticationPage">
            <div class="p-col-12 logo-container">
                <img [src]="assestBaseUrl + 'layout/images/lionO360_logo1.png'"  alt="logo-dark" />
            </div>
            <ng-container *ngIf="mfaType === 'AuthenticatorApp'">
                <h6>{{authenEmailId}}</h6>
                <h5>Approve sign in request</h5>
                <div class="p-d-flex p-mb-2">
                    <span class="pi pi-lock p-mr-2" style="font-size: 20px;"></span>
                    <p class="p-text-left">Open your Authenticator app, and enter the number shown to sign in.</p>
                </div>
                <div style="padding-left: 26px;">
                    <input type="text" class="p-inputtext-sm" placeholder="Enter your 6 digit code" pInputText
                        [(ngModel)]="enteredCode" (keypress)="preventSpace($event)"/>
                </div>
                <p class="p-text-left" style=" margin-top: 10px; padding-left: 26px;">No numbers in your app? Make sure
                    to upgrade to the latest version.</p>
            </ng-container>
            <!-- authentication page sms -->
            <ng-container *ngIf="mfaType === 'SMS'">
                <h6>{{mfaKey}}</h6>
                <h6>{{mfaMessage}}</h6>
                <input type="text" pInputText style="width: 300px;" [(ngModel)]="enteredCode" placeholder="Enter your 6 digit code" (keypress)="preventSpace($event)" />
               <span class="p-mt-1">Didn't receive the Code? Click Resend in {{ formatTimer() }}</span> 
            </ng-container>
            <!-- authentication page email -->
            <ng-container *ngIf="mfaType === 'Email'">
                <h6>{{mfaKey}}</h6>
                <h6>{{mfaMessage}}</h6>
                <input type="text" pInputText style="width: 300px;" [(ngModel)]="enteredCode" placeholder="Enter your 6 digit code"   (keypress)="preventSpace($event)" />
                <span class="p-mt-1">Didn't receive the Code? Click Resend in {{ formatTimer() }}</span> 
            </ng-container>
            <div class="p-field-checkbox p-mt-2">
                <p-checkbox [binary]="true" [(ngModel)]="rememberSetUp"></p-checkbox>
                <label>Remember this device for 30 days</label>
            </div>

            <div class="p-col-12 p-d-flex p-jc-between p-mt-1">
                <button *ngIf="authenticationData.MFAType === 'SMS' || authenticationData.MFAType === 'Email'" type="button" class="p-button p-button-secondary p-mr-2" pButton label="Resend" [disabled]="resendButtonDisabled" (click)="resendOTP()"></button>
                <button type="button" class="p-button p-button-secondary" [disabled]="enteredCode?.length <= 0" pButton label="Submit" (click)="onSubmitAuthenPage()"></button>
            </div>
            <button type="button" class="p-mt-0 p-button-secondary" pButton label="Re-Set Authentication"
                (click)="reSetupAuthen()"></button>
            <button pButton type="button" label="Back" (click)="backAuthenPage()"
                class="p-mt-3 p-button-secondary"></button>
        </div>
        <p-confirmDialog [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>
        <p-dialog [(visible)]="displayResetupAuthen" [modal]="true" [closable]="false" [contentStyle]="{'min-height':'200px'}"
            [style]="{width:'50vw'}">
            <ng-template pTemplate="header">
                <div style="display: flex; justify-content: center; width: 100%;">
                    <h5 class="p-mb-0">Re-Set Authentication</h5>
                </div>
            </ng-template>
            <div class="card">
                <div class="p-grid p-justify-center">
                    <div class="p-col-12">
                        <label for="enterBackupCode"  style="font-size: larger;"><strong>Recovery Code</strong></label>
                    </div>
                    <div class="p-col-12 p-md-6">
                        <input id="enterBackupCode" type="text" placeholder="Enter your recovery code" pInputText
                            [(ngModel)]="enterBackupCode" (keypress)="preventSpace($event)"/>
                    </div>
                </div>
            </div>

            <p-footer class="p-d-flex p-jc-between">
                <button type="button" pButton label="Cancel"  (click)="onCancelResetAuthen()"></button>
                <button type="button" pButton label="Submit" [disabled]="!enterBackupCode" (click)="onSubmitReSetup()"></button>
               
            </p-footer>
        </p-dialog>

        <div class="auth-footer" *ngIf="authenticationPage">
            <h6 class="p-mt-3">Welcome to LionOBytes</h6>
        </div>
    </div>
</div>


<!-- Add this code where you want to display the pop-up -->
<p-dialog [(visible)]="displayBackupCode" [modal]="true" [closable]="false" 
[contentStyle]="{'min-height':'200px'}"
[style]="{width:'50vw'}" [closable] maskStyleClass="high-z-index">
    <ng-template pTemplate="header">
        <div style="display: flex; justify-content: center; width: 100%;">
            <h3 class="p-mb-0">Recovery Code</h3>
        </div>
    </ng-template>
    <div class="content">
        <p class="p-mb-0 p-ml-5 p-mb-5">Store this code somewhere safe. It's a one-time code you
            can use to sign in to your
            account if you ever lose
            access to your authenticator app.</p>
        <div class="backup-code">
            {{recoveryCode}}
            <span class="btnBars" pTooltip="Copy Recovery Code" tooltipPosition="top" (click)="copyBackupCode()">
                <i class="pi pi-copy"></i>
            </span>
            <span class="btnBars" pTooltip="Download as PDF" tooltipPosition="top" (click)="downloadPDF()">
                <i class="pi pi-download"></i>
            </span>
        </div>
        <p class="p-mb-0 p-ml-5 p-mb-5">This code won't be displayed again. If you ever lose
            access to your device and this
            code, you’ll need to
            contact Administrator to access your account. After this code is used, you must
            immediately update your
            multi-factor authentication methods to keep your account secure.</p>
    </div>
    <p-footer>
        <button type="button" pButton label="Done" (click)="onDoneBackupCode()"></button>
    </p-footer>
</p-dialog>

<!-- download pdf -->
<div class="container" id="printableArea" style="display: none">
    <table width="100%" border="0" cellpadding="0" align="center">
        <tr>
            <td style="font-weight:bold;text-align: center;font-size:16px;padding-bottom:15px">Recovery Code</td>
        </tr>
        <tr>
            <td style="padding-bottom:15px">Store this code somewhere safe. It's a one-time code you
                can use to sign in to your
                account if you ever lose
                access to your authenticator app.</td>
        </tr>
        <tr>
            <td style="font-weight:bold;text-align: center;font-size:20px;padding:10px;background:#ddd;">
                {{recoveryCode}}
            </td>
        </tr>
        <tr>
            <td style="padding-top:15px">This code won't be displayed again. If you ever lose
                access to your device and this
                code, you’ll need to
                contact Administrator to access your account. After this code is used, you must
                immediately update your
                multi-factor authentication methods to keep your account secure.</td>
        </tr>
    </table>
</div>